export class ConverterFunctionAdapter {
    constructor(decoder, encoder) {
        this.decoder = decoder;
        this.encoder = encoder;
    }
    encode(value) {
        return this.encoder(value);
    }
    decode(value) {
        return this.decoder(value);
    }
}
